import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const AdjustIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "32"}
      height={height ?? "30"}
      viewBox="0 0 32 30"
      fill="none"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M16.151 29.5995C15.5089 29.5995 14.9888 29.0734 14.9888 28.4239V1.31823C14.9888 0.668683 15.5089 0.142578 16.151 0.142578C16.7931 0.142578 17.3132 0.668683 17.3132 1.31823V28.4239C17.3132 29.0734 16.7931 29.5995 16.151 29.5995Z"
        fill="currentColor"
      />
      <path
        d="M27.2238 29.457C26.5816 29.457 26.0615 28.9309 26.0615 28.2813V1.17565C26.0615 0.526105 26.5816 0 27.2238 0C27.8659 0 28.386 0.526105 28.386 1.17565V28.2813C28.386 28.9309 27.8659 29.457 27.2238 29.457Z"
        fill="currentColor"
      />
      <path
        d="M4.22717 29.5995C3.58504 29.5995 3.06494 29.0734 3.06494 28.4239V1.31823C3.06494 0.668683 3.58504 0.142578 4.22717 0.142578C4.86931 0.142578 5.38941 0.668683 5.38941 1.31823V28.4239C5.38941 29.0734 4.86931 29.5995 4.22717 29.5995Z"
        fill="currentColor"
      />
      <path
        d="M20.3781 22.7456V19.3234C20.3781 18.8542 20.1311 18.4211 19.7292 18.187L16.7994 16.4764C16.3984 16.2422 15.9035 16.2422 15.5016 16.4764L12.5718 18.187C12.1708 18.4211 11.9229 18.8551 11.9229 19.3234V22.7456C11.9229 23.2148 12.1698 23.6479 12.5718 23.882L15.5016 25.5926C15.9025 25.8268 16.3974 25.8268 16.7994 25.5926L19.7292 23.882C20.1301 23.6479 20.3781 23.2139 20.3781 22.7456Z"
        fill="currentColor"
      />
      <path
        d="M31.4499 14.4809V11.0588C31.4499 10.5895 31.2029 10.1565 30.801 9.92232L27.8712 8.21175C27.4702 7.9776 26.9753 7.9776 26.5733 8.21175L23.6435 9.92232C23.2426 10.1565 22.9946 10.5905 22.9946 11.0588V14.4809C22.9946 14.9502 23.2416 15.3832 23.6435 15.6174L26.5733 17.328C26.9743 17.5621 27.4692 17.5621 27.8712 17.328L30.801 15.6174C31.2019 15.3832 31.4499 14.9492 31.4499 14.4809Z"
        fill="currentColor"
      />
      <path
        d="M8.45426 16.4389V13.0168C8.45426 12.5475 8.20729 12.1145 7.80535 11.8803L4.87556 10.1698C4.47459 9.9356 3.97967 9.9356 3.57773 10.1698L0.647936 11.8803C0.246966 12.1145 -0.000976562 12.5485 -0.000976562 13.0168V16.4389C-0.000976562 16.9082 0.245998 17.3412 0.647936 17.5754L3.57773 19.286C3.9787 19.5201 4.47362 19.5201 4.87556 19.286L7.80535 17.5754C8.20632 17.3412 8.45426 16.9072 8.45426 16.4389Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AdjustIcon;
